var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.9027 10.8627L21.3482 2.39407H19.5838L13.119 9.74727L7.95547 2.39407H2L9.8082 13.5134L2 22.3941H3.76443L10.5915 14.6288L16.0445 22.3941H22L13.9023 10.8627H13.9027ZM11.4861 13.6114L10.695 12.5041L4.40018 3.69375H7.11025L12.1902 10.804L12.9813 11.9113L19.5847 21.1535H16.8746L11.4861 13.6118V13.6114Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXW);
export default __webpack_public_path__ + "static/media/x-w.d55c6c8ebfd696e4876e563e613dbfab.svg";
export { ForwardRef as ReactComponent };